// src/app/core/guards/auth.guard.ts
import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate  {

   private router = inject(Router);
    private authService = inject(AuthService);
  constructor() {}
// In your AuthGuard
canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
  return this.authService.checkAuth().pipe(
    map(isAuth => {
      if (isAuth) {
        return true;
      } else {
        return this.router.createUrlTree(['/login']);
      }
    })
  );
}
}
